import React from "react";
import westside_image from "../../../assets/images/westside_image.png";

const SubscriptionHistoryCard = ({setSubHistoryModal}) => {
  return (
    <div className="flex justify-between items-center rounded-2xl w-[60%] shadow-md p-4 my-4 cursor-pointer" onClick={() => setSubHistoryModal(true)}>
      <div className="flex">
        <img
          src={westside_image}
          alt="westside_image"
          className="w-8 object-contain"
        />
        <p className="text-[18px] font-bold ml-2">Westside</p>
      </div>
      <p className="text-[14px] font-bold">Organiser Pro</p>
    </div>
  );
};

export default SubscriptionHistoryCard;
